/**
 * Copyright © VNG Realisatie 2025
 * Licensed under the EUPL
 */

import * as TomSelect from 'tom-select'

enableTomSelectInstances()

document.body.addEventListener('htmx:afterSettle', function () {
  enableTomSelectInstances()
});

function enableTomSelectInstances() {
  document
    .querySelectorAll('.tom-select')
    .forEach((el) => {
      let settings = {};
      new TomSelect(el, settings);
    })
}
